// extracted by mini-css-extract-plugin
module.exports = {"patientFormContainer":"patient-form-container__21hbr","patientFormWrapper":"patient-form-wrapper__1ofJg"};